import React from "react";

function DeleteChilds() {
  return <div>DeleteChilds</div>;
}

export default DeleteChilds;
